import React, { useState } from "react";

import {
  ChevronDownIcon as ChevronDown,
  ChevronRightIcon as ChevronRight
} from "@packages/ds";
import moment from "moment";
import { useIntl } from "react-intl";

import { ServiceProcess } from "Api/adminAgent/types/ServiceProcess.type";
import { Tooltip } from "ds/Tooltip";

import { convertBytesToMaxUnit } from "../utils/convertBytesToMaxUnit";
import { convertDateStringToHuman } from "../utils/convertDateStringToHuman";

import { OptionsButton } from "./OptionsButton";
import * as S from "./TreeNode.styles";

type TreeNodeProps = {
  serviceProcess: ServiceProcess;
  currentOpen: number;
  setCurrentOpen: (currentOpen: number) => void;
  level?: number;
};

export const TreeNode = ({
  serviceProcess,
  currentOpen,
  setCurrentOpen,
  level = 0
}: TreeNodeProps) => {
  const { formatMessage } = useIntl();
  const [open, setOpen] = useState(level === 0 ? true : false);

  const hasChildren = !!serviceProcess.children?.length;
  const separators = [...Array(level).keys()];

  return (
    <>
      <tr className={serviceProcess.pid === currentOpen ? "active" : ""}>
        <td>
          <S.Accordion>
            {separators.map(key => (
              <S.VerticalBarContainer key={key}>
                <S.VerticalBar />
              </S.VerticalBarContainer>
            ))}

            {open && hasChildren && (
              <ChevronDown
                color="#C9D0E4"
                cursor="pointer"
                onClick={() => setOpen(!open)}
              />
            )}

            {!open && hasChildren && (
              <ChevronRight
                color="#C9D0E4"
                cursor="pointer"
                onClick={() => setOpen(!open)}
              />
            )}

            {!hasChildren && <S.Separator />}

            <S.SeparatorX />

            {serviceProcess.name || "-"}
          </S.Accordion>
        </td>
        <td>{serviceProcess.pid}</td>
        <td>{serviceProcess.parent_pid || "-"}</td>
        <td>{serviceProcess.children_number}</td>
        <td className={serviceProcess.status === "D" ? "d-status" : ""}>
          {serviceProcess.status || "-"}
        </td>
        <td>{serviceProcess.cpu_percent.toFixed(1)}</td>
        <td>{convertBytesToMaxUnit(serviceProcess.rss)}</td>
        <td>{serviceProcess.username || "-"}</td>
        <td>
          <Tooltip
            align="end"
            sideOffset={8}
            tooltip={formatMessage(
              {
                id: "services.process.colum.run_tooltip"
              },
              {
                date: moment(serviceProcess.create_time).format(
                  "HH:mm:ss MMMM D YYYY"
                )
              }
            )}
          >
            {convertDateStringToHuman(serviceProcess.create_time)}
          </Tooltip>
        </td>
        <td>
          <OptionsButton
            process={serviceProcess as any}
            setCurrentOpen={open =>
              setCurrentOpen(open ? serviceProcess.pid : 0)
            }
          />
        </td>
      </tr>

      {open &&
        !!serviceProcess.children?.length &&
        serviceProcess.children.map(serviceProcessChildren => (
          <TreeNode
            key={serviceProcessChildren.pid}
            serviceProcess={serviceProcessChildren}
            currentOpen={currentOpen}
            setCurrentOpen={setCurrentOpen}
            level={level + 1}
          />
        ))}
    </>
  );
};
